import { Box, Stack, Typography, useTheme } from "@mui/material";
import { AgentText, shiftText, Weekdays } from "../../data/texts";
import { AgentShift } from "../../types/owner";

interface AvailableHoursProps {
  shifts: AgentShift;
  morningHours: { start: number; end: number };
  nightHours: { start: number; end: number };
}

export const AvailableHours = ({
  shifts,
  morningHours,
  nightHours,
}: AvailableHoursProps) => {
  const theme = useTheme();

  const isDayoff = (day: Weekdays) => {
    return day === Weekdays.SATURDAY;
  };

  const getHoursByShift = (shift: AgentShift) => {
    if (shift === "morning") {
      return morningHours;
    }
    return nightHours;
  };

  if (!shifts) {
    return;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography
        fontWeight={"500"}
        fontSize={"20px"}
        marginBottom={"10px"}
        sx={{ color: theme.palette.text.primary }}
      >
        {AgentText.AVAILABLE_HOURS}
      </Typography>
      <Stack direction={"row"} flexWrap={"wrap"} gap={"12px"}>
        {Object.values(Weekdays).map((day, index) => (
          <Stack
          key={index}
            sx={{
              border: `${
                isDayoff(day) ? theme.palette.error.light : "#1B75BB"
              } solid 1px`,
              borderRadius: "111px",
              width: "fit-content",
              paddingBlock: "2px",
              paddingInline: "20px",
              gap: "4px",
            }}
            direction={"row"}
          >
            <Typography
              color={isDayoff(day) ? theme.palette.error.light : "#4C4E64DE"}
              fontWeight={"600"}
            >
              {day}
            </Typography>
            <Typography
              color={isDayoff(day) ? theme.palette.error.light : "#4C4E64DE"}
              fontWeight={"300"}
            >
              {shiftText[shifts]
                .replace("%start%", `${getHoursByShift(shifts).start}:00`)
                .replace("%end%", `${getHoursByShift(shifts).end}:00`)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
